import { render, staticRenderFns } from "./ReservationsButtons.vue?vue&type=template&id=0c1997b2&"
import script from "./ReservationsButtons.vue?vue&type=script&lang=js&"
export * from "./ReservationsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c1997b2')) {
      api.createRecord('0c1997b2', component.options)
    } else {
      api.reload('0c1997b2', component.options)
    }
    module.hot.accept("./ReservationsButtons.vue?vue&type=template&id=0c1997b2&", function () {
      api.rerender('0c1997b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/ReservationsButtons.vue"
export default component.exports